import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { StandardOSExport } from 'src/app/shared/models/export-models/standard-os-export.model';
import { StandardPremium } from '../../models/calculator-models/stamdard-premium.model';
import { AdutOSExport } from '../../models/export-models/adut-os-export.model';
import { AdutPremiumExport } from '../../models/export-models/adut-premium-export.model';
import { SecurityOSExport } from '../../models/export-models/security-os-export.model';
import { SecurityPremiumExport } from '../../models/export-models/security-premium-export.model';
import { SecurityCreditExport } from '../../models/export-models/security-credit-export.model';
import { ScholershipPremiumExport } from '../../models/export-models/scholarship-premium-export.model';
import { ScholershipOSExport } from '../../models/export-models/scholarship-os-export.model';
import { GoldenAutumnExport } from '../../models/export-models/golden-autumn-export.model';
import { NajlifeOSExport } from '../../models/export-models/naj-life-os-export.model';
import { NajlifePremiumExport } from '../../models/export-models/naj-life-premium-export.model';

@Injectable({
    providedIn: 'root'
})
export class ExportCalculatorService {

    constructor(private httpClient: HttpClient) { }

    exportStandardOS(standardOS: StandardOSExport) {
        return this.httpClient.post('api/quote/standard', standardOS.data, { observe: 'response', responseType: 'blob' });
    }

    exportStandardPremium(standardPremium: StandardPremium) {
        return this.httpClient.post('api/quote/standardpremium', standardPremium.data, { observe: 'response', responseType: 'blob' })
    }

    exportAdutOS(adutOS: AdutOSExport) {
        return this.httpClient.post('api/quote/adut', adutOS.data, { observe: 'response', responseType: 'blob' });
    }

    exportAdutPremium(adutPremium: AdutPremiumExport) {
        return this.httpClient.post('api/quote/adutpremium', adutPremium.data, { observe: 'response', responseType: 'blob' });
    }

    exportSecurityOS(securityOS: SecurityOSExport) {
        return this.httpClient.post('api/quote/risk', securityOS.data, { observe: 'response', responseType: 'blob' });
    }

    exportSecurityPremium(securityPremium: SecurityPremiumExport) {
        return this.httpClient.post('api/quote/riskpremium', securityPremium.data, { observe: 'response', responseType: 'blob' });
    }

    exportSecurityCredit(securityCredit: SecurityCreditExport) {
        return this.httpClient.post('api/quote/credit', securityCredit.data, { observe: 'response', responseType: 'blob' });
    }

    exportSecurityCash(securityCash: SecurityCreditExport) {
        return this.httpClient.post('api/quote/cash', securityCash.data, { observe: 'response', responseType: 'blob' });
    }

    exportScholarshipOS(scholarshipOS: ScholershipOSExport) {
        return this.httpClient.post('api/quote/grant', scholarshipOS.data, { observe: 'response', responseType: 'blob' });
    }

    exportScholarshipPremium(scholarshipPremium: ScholershipPremiumExport) {
        return this.httpClient.post('api/quote/grantpremium', scholarshipPremium.data, { observe: 'response', responseType: 'blob' });
    }

    exportGoldenAutumn(goldenAutumn: GoldenAutumnExport) {
        return this.httpClient.post('api/quote/goldenautumn', goldenAutumn.data, { observe: 'response', responseType: 'blob' });
    }

    exportNajlifeOS(najlifeOS: NajlifeOSExport) {
        return this.httpClient.post('api/quote/najlife', najlifeOS.data, { observe: 'response', responseType: 'blob' });
    }

    exportNajlifePremium(najlifePremium: NajlifePremiumExport) {
        return this.httpClient.post('api/quote/najlifepremium', najlifePremium.data, { observe: 'response', responseType: 'blob' });
    }

    exportProgressive(progressive: any) {
        return this.httpClient.post('api/quote/progressive', progressive, { observe: 'response', responseType: 'blob' }).toPromise()
    }

    exportStandardOSVIP(standardOS: StandardOSExport) {
        return this.httpClient.post('api/quote/standardvip', standardOS.data, { observe: 'response', responseType: 'blob' });
    }

    exportStandardPremiumVIP(standardOS: StandardOSExport) {
        return this.httpClient.post('api/quote/standardpremiumvip', standardOS.data, { observe: 'response', responseType: 'blob' });
    }

    exportSecurityOSVIP(securityOS: SecurityOSExport) {
        return this.httpClient.post('api/quote/riskvip', securityOS.data, { observe: 'response', responseType: 'blob' });
    }

    exportSecurityPremiumVIP(securityOS: SecurityOSExport) {
        return this.httpClient.post('api/quote/riskpremiumvip', securityOS.data, { observe: 'response', responseType: 'blob' });
    }

    exportScholarshipOSVIP(scholarshipOS: ScholershipOSExport) {
        return this.httpClient.post('api/quote/grantvip', scholarshipOS.data, { observe: 'response', responseType: 'blob' });
    }

    exportScholarshipPremiumVIP(scholarshipPremium: ScholershipPremiumExport) {
        return this.httpClient.post('api/quote/grantpremiumvip', scholarshipPremium.data, { observe: 'response', responseType: 'blob' });
    }

}